export const STARTER_KIT_MATERIAL_NAME = 'Operation 36 Junior Starter Kit'
export const GOLF_CLUBS_MATERIAL_NAME = 'Operation 36 Golf Clubs'

export const getOrderMessage = (material) => {
  if (material.name === STARTER_KIT_MATERIAL_NAME) {
    return 'Order Starter Kit'
  } if (material.name === GOLF_CLUBS_MATERIAL_NAME) {
    return 'Order Clubs Now'
  } else {
    return `Order your ${material.name}`
  }
}

export const getPositiveToggleText = (material) => {
  if (material.name === STARTER_KIT_MATERIAL_NAME) {
    return 'Yes, I do.'
  } if (material.name === GOLF_CLUBS_MATERIAL_NAME) {
    return `Yes, send me more information on ${material.name}.`
  } else {
    return 'Yes.'
  }
}

export const getNegativeToggleText = (material) => {
  if (material.name === STARTER_KIT_MATERIAL_NAME) {
    return 'No, I don\'t. I already have it.'
  } if (material.name === GOLF_CLUBS_MATERIAL_NAME) {
    return 'No, I already have clubs.'
  } else {
    return 'No.'
  }
}

export const getMaterialDescription = (material) => {
  if (material.name === STARTER_KIT_MATERIAL_NAME) {
    return (
      <div>
        <span className='font-weight-bold'>This program requires a starter kit.</span> Please follow the link below to order it.
        This will be shipped directly to you.
      </div>
    )
  } if (material.name === GOLF_CLUBS_MATERIAL_NAME) {
    return (
      <>
        <div>
          <span className='font-weight-bold'>If you need clubs:</span> Use our online fitting tool to order your Op 36 Clubs - custom-fit by height
          and shipped directly to your door.
        </div>

        <div>
          <span className='font-weight-bold'>If you already have clubs:</span> You&apos;re all set! Head to your dashboard
          for class info and schedules.
        </div>
      </>
    )
  } else {
    return material.description
  }
}
